import { Tooltip } from '@mui/material';
import { COUNTRY_CODE_TO_FLAG } from '@/constants';
import { Container, NameWrapper, PackageId, PackageName } from './styled';
import { ComposedPackageNameProps } from './types';

export const ComposedPackageName = ({
  countryCode = '',
  packageId = '',
  packageName = '',
}: ComposedPackageNameProps) => {
  const formattedPackageName = packageName?.replaceAll('/', '/\u200B');

  return (
    <Container>
      <NameWrapper>
        <Tooltip title={countryCode}>
          <span>{COUNTRY_CODE_TO_FLAG?.[countryCode]}</span>
        </Tooltip>
        <Tooltip title={formattedPackageName}>
          <PackageName>{formattedPackageName}</PackageName>
        </Tooltip>
      </NameWrapper>
      <PackageId alignLeft={!!countryCode}>{packageId}</PackageId>
    </Container>
  );
};

export default ComposedPackageName;
